/* eslint-disable import/no-extraneous-dependencies */
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices

import productReducer from './slices/product';
import hotelReducer from './slices/hotel';
import holidaysReducer from './slices/holidays';
import flightReducer from './slices/flight';
import activityReducer from './slices/activity';
import safariReducer from './slices/safari';
import userReducer from './slices/user';
import tourReducer from './slices/tourpackage';
import staycationReducer from './slices/staycation';
import busReducer from './slices/bus';
import visaReducer from './slices/visa';
import commonReducer from './slices/common';
import cardReducer from './slices/cards';
import investmentsReducer from './slices/investments';
import realEstateReducer from './slices/real-estate';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

export const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const hotelPersistConfig = {
  key: 'hotel',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const holidaysPersistConfig = {
  key: 'holiday',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const flightPersistConfig = {
  key: 'flight',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const activityPersistConfig = {
  key: 'activity',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const safariPersistConfig = {
  key: 'safari',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const userPersistConfig = {
  key: 'user',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const tourPersistConfig = {
  key: 'tour',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const staycationPersistConfig = {
  key: 'staycation',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const busPersistConfig = {
  key: 'bus',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const visaPersistConfig = {
  key: 'visa',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
export const commonPersistConfig = {
  key: 'common',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

export const investmentsConfig = {
  key: 'investment',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

export const realEstateConfig = {
  key: 'realEstate',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const rootReducer = combineReducers({
  // mail: mailReducer,
  // chat: chatReducer,
  // calendar: calendarReducer,
  // kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  hotel: persistReducer(hotelPersistConfig, hotelReducer),
  holiday: persistReducer(holidaysPersistConfig, holidaysReducer),
  flight: persistReducer(flightPersistConfig, flightReducer),
  activity: persistReducer(activityPersistConfig, activityReducer),
  safari: persistReducer(safariPersistConfig, safariReducer),
  user: persistReducer(userPersistConfig, userReducer),
  tour: persistReducer(tourPersistConfig, tourReducer),
  staycation: persistReducer(staycationPersistConfig, staycationReducer),
  bus: persistReducer(busPersistConfig, busReducer),
  visa: persistReducer(visaPersistConfig, visaReducer),
  common: persistReducer(commonPersistConfig, commonReducer),
  cards: persistReducer(commonPersistConfig, cardReducer),
  investment: persistReducer(investmentsConfig, investmentsReducer),
  realEstate: persistReducer(realEstateConfig, realEstateReducer),
});

export default rootReducer;
